// extracted by mini-css-extract-plugin
export default {"tupacGrid":"en-z","tupacHeader":"fn-z","tupacHeader2":"gn-z","tupacMenu":"hn-z","tupacMenu2":"in-z","tupacMain":"jn-z","tupacMain2":"kn-z"};